import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import NewCalibration from './components/NewCalibration';
import EditCalibration from './components/EditCalibration';
import CalibrationsList from './components/CalibrationsList';

const Calibrations = () => {
  const [listRequiresReload, setListRequiresReload] = useState(true);
  const [selectedCalibration, setSelectedCalibration] = useState();

  return (
    <Container>
      <Row>
        <Col md={12}>
          <h3 className="page-title">Calibrations Management</h3>
          <h3 className="page-subhead subhead">Manage workspace calibrations</h3>
        </Col>
      </Row>
      <Row>
        <Col md={8}>
          <CalibrationsList setSelectedCalibration={setSelectedCalibration} setListRequiresReload={setListRequiresReload} selectedCalibration={selectedCalibration} listRequiresReload={listRequiresReload} />
        </Col>
        <Col md={4}>
          {!selectedCalibration && <NewCalibration setSelectedCalibration={setSelectedCalibration} setListRequiresReload={setListRequiresReload} selectedCalibration={selectedCalibration} />}
          {selectedCalibration && <EditCalibration setSelectedCalibration={setSelectedCalibration} setListRequiresReload={setListRequiresReload} selectedCalibration={selectedCalibration} />}
        </Col>
      </Row>
    </Container>
  );
};

export default Calibrations;